export default __webpack_public_path__ + "static/icon-four-way-stretch-052071d9671d96d09df7ca1950bff344.webp";